import { ReactNode } from 'react'

import { TextProps } from '@hhgtech/hhg-components/mantine'
import { BoxProps } from '@mantine/core'

import { Header } from './header'
import useStyles from './index.styles'
import { Wrapper } from './wrapper'

export type HeaderProps = {
  title?: string
  titleAs?: React.FC<TextProps['as']>
  description?: string
  icon?: string
  bgColor?: string
  layout?: 'normal' | 'withIcon'
}

export type SectionWrapperProps = {
  children: ReactNode
  innerClass?: 'wide-container' | 'narrow-container' | 'hhg-page-container'
  defaultColor?: string
  applyH1?: boolean
} & HeaderProps

type Props = SectionWrapperProps & BoxProps

const _SectionWrapper = ({
  title,
  titleAs,
  description,
  icon,
  children,
  layout = 'normal',
  innerClass,
  styles,
  className,
  classNames,
  applyH1,
  ...rest
}: Props) => {
  const { classes, cx } = useStyles(undefined, {
    name: 'ServiceConnections__SectionWrapper',
    styles,
    classNames,
  })
  return (
    <Wrapper
      classNames={{
        root: cx(className, 'section-wrapper', classes.root),
        innerClass: classes.innerClass,
      }}
      {...rest}
    >
      {(title || description) && (
        <Header
          className={classes.header}
          {...{
            title,
            description,
            icon,
            titleAs:
              titleAs || ((applyH1 ? 'h1' : undefined) as TextProps['as']),
            layout,
          }}
        />
      )}
      {children || children}
    </Wrapper>
  )
}

interface CompoundedComponent extends React.ForwardRefExoticComponent<Props> {
  Header: typeof Header
  Wrapper: typeof Wrapper
}

const SectionWrapper = (_SectionWrapper as unknown) as CompoundedComponent
SectionWrapper.Header = Header
SectionWrapper.Wrapper = Wrapper

export default SectionWrapper
